import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Company information (static data)
const companyInfo = {
  address: "1208 136th Street Court South, Tacoma, Washington, 98444",
  phones: ["(206) 712-0952", "(253) 252-8944"],
  emails: ["info@uskesupplyllc.com", "mngugi@uskesupplyllc.com"],
  administrator: "Mary Ngugi"
};

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get(`${API}/categories`)
      .then(res => setCategories(res.data))
      .catch(() => {});
  }, []);
  return (
    <footer className="bg-slate-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-white">USKE SUPPLY LLC</h3>
            <p className="text-slate-300 mb-4">
              Your trusted partner for quality general supplies. Serving businesses across Washington and beyond.
            </p>
            <p className="text-sm text-slate-400">Administrator: {companyInfo.administrator}</p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-300 hover:text-purple-400 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-slate-300 hover:text-purple-400 transition-colors">
                  All Products
                </Link>
              </li>
              <li>
                <Link to="/track-order" className="text-slate-300 hover:text-purple-400 transition-colors">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-purple-400 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-300 hover:text-purple-400 transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <a href="https://privateemail.com/" target="_blank" rel="noopener noreferrer" className="text-slate-300 hover:text-purple-400 transition-colors">
                  Webmail Portal
                </a>
              </li>
            </ul>
          </div>

          {/* Product Categories */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Categories</h4>
            <ul className="space-y-2">
              {categories.map(cat => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-slate-300 hover:text-purple-400 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin className="h-5 w-5 text-purple-400 flex-shrink-0 mt-0.5" />
                <span className="text-slate-300 text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-5 w-5 text-purple-400" />
                <div className="flex flex-col">
                  <a href={`tel:${companyInfo.phones[0]}`} className="text-slate-300 hover:text-purple-400 transition-colors text-sm">
                    {companyInfo.phones[0]}
                  </a>
                  <a href={`tel:${companyInfo.phones[1]}`} className="text-slate-300 hover:text-purple-400 transition-colors text-sm">
                    {companyInfo.phones[1]}
                  </a>
                </div>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-5 w-5 text-purple-400" />
                <a href={`mailto:${companyInfo.emails[0]}`} className="text-slate-300 hover:text-purple-400 transition-colors text-sm">
                  {companyInfo.emails[0]}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} USKE SUPPLY LLC. All rights reserved.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-slate-400 hover:text-purple-400 transition-colors">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-purple-400 transition-colors">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="text-slate-400 hover:text-purple-400 transition-colors">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
